import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, UntypedFormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { map } from 'rxjs/operators';
import { SearchTableParam } from 'src/app/models/base-search.model';
import { AuthService } from 'src/app/services/auth.service';
import { TheUserSearch, UserSearch } from 'src/app/users-management/models/data-models';
import { UserApiService } from 'src/app/users-management/user-api.service';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { ToastrService } from 'ngx-toastr';
declare const $: any;

@Component({
  selector: 'app-add-notifications',
  templateUrl: './add-notifications.component.html',
  styleUrls: ['./add-notifications.component.css']
})
export class AddNotificationsComponent implements OnInit {
  notification: any = {};
  isLinear = true;
  platforms = [];

  filteredTopic = [];
  topics = [];
 // selectedTopic = null;
  selectedTopic = [];

  selectedGroup = [];
  selectedTemplate = null;
  selectedKeyValue = null;
  selectedPlatform = null;
  targetType = 1;
  clickButton: boolean;
  site: any = {};
  notificationPageType = null;
  usersList = [];
  usersListReplacingUserId: any = [];
  selectedUser = [];
  selectedGrops = [];
  messageText = null;
  emailBody = "";
  emailTitle = "";
  index: number = 0;
  size: number = 100;
  userLoading = false;
  userTotlaRecords = 0;
  platformCheck: boolean;
  groupCheck: boolean;
  sendViaCheck: number;
  sendViaCheckTempleat: any;
  groupLst = [];
  theGroupList={}; 
  NotificationType;
  roleId = [];
  TempleatContanet = "";
  userDBSettings = {
    singleSelection: false,
    text: "Select User",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    primaryKey: "userId",
    labelKey: "name",
    noDataLabel: "Search User...",
    enableSearchFilter: true,
    searchBy: ['fullName']
  }

  userGroupDBSettings = {
    singleSelection: false,
    text: "Select group",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    primaryKey: "grouprId",
    labelKey: "group name",
  }


  templateId: any;
  curuntKey: {
    itemData: { key: '', value: '' },
    index: any | null
  }



  isOpen = false;
  templateList: any[] = [];
  userRequired = false;

  //# this will contain the selected marked form the htmle 
  context = {
    message: ''
  };
  //# here we will save all the selected items 
  keysvalue = [];
  userInfoWithParams = {};
  // # this taken form the resopns of the users (getUsers()) 
  // # this will be the value for replacing in the prams in the templeat 
  keysConfiguration = ['fullName', 'email', 'phoneNumber', 'roleName', 'userName', 'userGroup'];


  filterForm: any = { searchValue: '', pageSize: 100000, pageNo: 0, emailTemplateSort: null };

  // platformCheck: boolean;
  // SendViaLst = [];
  // sendBySelected: any;
  // notificationFormGroup: FormGroup;
  // targetFormGroup: FormGroup;

  // mailForm = new FormGroup({
  //   messageTitle: new FormControl('', [Validators.required]),
  //   selectedUsers: new FormArray([], [Validators.required]),
  //   messageBody: new FormControl('', [Validators.required])
  // });

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
     private snotifyService: ToastrService,
    private domSanitizer: DomSanitizer,
    private userService: UserApiService) {
    

  }

  ngOnInit() {
    this.getSiteDetailes();
    // this.selectedUser = [{userId: 471, email: 'M.Zawaideh@eskadenia.com', userName: 'M.Zawaideh', fullName: 'Mona Zawaideh', password: null}
    // ];

    this.activeRoute.queryParams.subscribe(params => {
      this.notificationPageType = params['type'];
      // console.log('notificationPageType', this.notificationPageType);
      // if (this.notificationPageType === 'sms') {
      // }
    });
    this.getUsers(true);
     this.getUserGroups();
    this.getTemplates()
    // this.notificationFormGroup = this.formBuilder.group({
    //   firstCtrl: ['', Validators.required]
    // });
    // this.targetFormGroup = this.formBuilder.group({
    //   secondCtrl: ['', Validators.required]
    // });

  }

  addUserToList($event) {
    // console.log($event)
  }

  getSiteDetailes() {
    let user = this.authService.getLoggedUser()
    this.site.id = user.siteId;
    this.platforms.push({
      id: 1,
      name: 'Android',
      bundleId: "com.eskadenia.homecutscustomer",
      siteName: 'Home cuts customer'
    },
      {
        id: 2,
        name: 'IOS',
        bundleId: "com.eskadenia.homecutscustomer",
        siteName: 'Home cuts customer'
        ,
      }, {
      id: 3,
      name: 'Personal',
      bundleId: "com.eskadenia.homecutscustomer",
      siteName: 'Home cuts customer'
    })
    this.topics.push(    
      {
        id: 1,
        name: 'Silver Members',
      },
      {
        id: 2,
        name: 'Golden Members',
      },
      {
        id: 3,
        name: 'Bronze Members',
      },
      {
        id: 4,
        name: 'Guest Users',
      },
      {
        id: 5,
        name: 'Marketing',
      },
    )
    // this.httpClient.get('/Sites/GetSiteDetails/' + this.site.id).subscribe((res: any) => {
    //   console.log('res site', res);
    //   this.site.settings = res.settings ? JSON.parse(res.settings) : {};
    //   this.site.bundleId = this.platforms = this.site.settings ? this.site.settings.bundleId : null;
    //   console.log('site.bundleId', this.site.bundleId);

    // });
  }

  getUsers(firstCall: boolean, name?) {
    this.userLoading = true;
    // let data = {
    //   Pagination: {
    //     Start: this.index, Number: this.size
    //   },
    //   Search: {
    //     PredicateObject: {
    //       'isExistInUser': null,
    //       'UserType': null,
    //       'CustomerGroupId': null,
    //       'FullName': (name) ? name : ''
    //     }
    //   },
    //   Sort: {}
    // }

    //   public getUsers() {
    //   this.params = {
    //     pagination: { start: this.index, number: this.size },
    //     search: this.filterForm.value
    //   }
    //   this.userService.getList(this.params).subscribe((result) => {
    //     console.log(result);
    //     this.dataSource = new MatTableDataSource<UserResponse>(result.items);

    //     this.dataLength = result.totalRecord;
    //   });
    // }

    //
    this.usersList = [];
    const params: SearchTableParam<TheUserSearch> = {
      pagination: { start: this.index, number: this.size },
      search: { name: name ? name : '', roleId: [], groupIds: this.selectedGroup.length == 0 ? null : this.selectedGroup }
    }
    this.userService.ThegetList(params)
      .subscribe((res: any) => {
        // Object.assign(res, {
        //   items: res.items.map(x => ({
        //     ...x,
        //     id: x.userId
        //   }))
        // })
        this.userLoading = false;
        if (firstCall) {

          this.usersList = res.items;

          // this.usersListReplacingUserId= res.items;
          // this.usersListReplacingUserId=
          //this.usersListReplacingUserId.map(user=>user.id =user.userId);
        } else {
          this.usersList = this.usersList.concat(res.items)
          // this.usersListReplacingUserId= res.items;
          // this.usersListReplacingUserId=
          //this.usersListReplacingUserId.map(user=>user.id =user.userId);
        }
        this.userTotlaRecords = res.totalRecord;
      });
    // this.httpClient.post(`/users/GetAllUsers`, params).subscribe((res: any) => {
    //   this.userLoading = false;
    //   if (firstCall) {
    //     this.usersList = res.items;
    //   } else {
    //     this.usersList = this.usersList.concat(res.items)
    //   }
    //   this.userTotlaRecords = res.totalRecord;
    // });
    //
  }


  //# get the UserGrops 
  getUserGroups() {
    this.httpClient.get(`/customergroups`).subscribe((res: any) => {
      let items = [] ; 
      items = res; 
      this.theGroupList = res ;
      for(let i = 0 ; i <items.length ; i++){
        if(items[i].topic!==null)
        {this.groupLst.push(items[i])}
      }
      console.log(this.groupLst)
    });
  }



  //# get all the eamil templeat in the system 
  getTemplates() {
    this.httpClient.get("/EmailTemplate/GetEmailTemplateByTypeId/2").subscribe((res: any) => {
      this.templateList = res;
    });
  }


  onScrollToEnd() {
    if (this.usersList.length < this.userTotlaRecords) {
      this.index++;

      this.getUsers(false);
    }
  }

  onScroll({ end }) {
    // console.log('test2');

  }

  targetSelect(event, source) {
    if (source === 'platform')
      this.platformCheck = event.target.checked;
    else if (source === 'email')
      this.fillTargetHandler(event.target.checked, 2);
    else if (source === 'users')
      this.fillTargetHandler(event.target.checked, 3);
    else if (source === 'phone')
      this.fillTargetHandler(event.target.checked, 1);
    else if (source === 'Topic') {
      this.sendViaCheck = 0;
      this.groupCheck = true;
    }
  }



  // # this for select the type of the tempelet 
  // # the tempelet  can be one time email or a Templeat 
  typeOfTemplete(event, source) {
    if (source === 'email') {
      this.fillTargetHandler(event.target.checked, 2);
      this.sendViaCheckTempleat = 2;
      this.selectedTemplate = null;
      this.changeTheTemplate();
      // this.keysvalue = [];
    }
    else if (source === 'template') {
      this.fillTargetHandler(event.target.checked, 1);
      this.sendViaCheckTempleat = 1;
      this.notification.messageTitle = null;
      this.notification.messageBody = null;

    }

  }




  fillTargetHandler(checked, value) {
    if (this.groupCheck)
      this.groupCheck = false;

    if (checked)
      this.sendViaCheck = value;
    else
      this.sendViaCheck = 0;
  }

  onSearch($event) {
    this.getUsers(true, $event.target.value);
  }




  // # this is old code for the notification

  // sendNotification() {

  //   let sendValue = [];
  //   let notificationType: number;
  //   let sendvalueArray = [];

  //   if (this.notificationPageType === 'notification') {
  //     notificationType = 1;
  //     if (this.sendViaCheck == 1) {
  //       sendvalueArray.push(this.notification.phone);
  //     }
  //     else if (this.sendViaCheck == 2) {
  //       sendvalueArray.push(this.notification.email);
  //     }
  //     else if (this.sendViaCheck == 3) {
  //       this.selectedUser.forEach(element => {
  //         sendvalueArray.push(element.userName);
  //       });

  //     } else if (this.sendViaCheck == 0) {
  //       sendValue = null;
  //     }
  //   }
  //   else if (this.notificationPageType === 'sms') {
  //     notificationType = 4;
  //     this.selectedUser.forEach(element => {
  //       sendvalueArray.push(element.phoneNumber);
  //     });
  //   }
  //   else if (this.notificationPageType === 'email') {
  //     notificationType = 3;
  //     this.selectedUser.forEach(element => {
  //       sendvalueArray.push(element.email);
  //     });
  //   }


  //   let data = {
  //     MessageTitle: this.notification.messageTitle,
  //     MessageBody: (this.notificationPageType !== 'email' && this.notificationPageType !== 'sms') ? this.notification.messageBody : $('.summernote').summernote('code'),
  //     PushNotificationOptions: {
  //       Topic: (!!this.selectedTopic) ? this.selectedTopic.topic : 0,
  //       DesitinationType: (this.notificationPageType === 'notification') ? this.selectedPlatform.name : 'Personal'
  //     },
  //     NotificationType: notificationType,
  //     SendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
  //     SendValue: sendvalueArray

  //   }

  //   this.httpClient.post(`/Notification/send`, data).subscribe((res: any) => {
  //     // this.groupLst = res;
  //     this.router.navigateByUrl('/notifications');
  //     this.snotifyService.success("", "Notification send successfully", {
  //       timeout: 2500,
  //       showProgressBar: true,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       titleMaxLength: 500
  //     });
  //   });
  // }



  SendTheNotification() {
    let notificationType: number;
    let sendvalueArray = [];
    let emailOption = {};
    if (this.selectedUser.length != 0 || this.selectedTopic.length!=0 ) {
      this.userRequired = false;
      if (this.notificationPageType === 'email') {
        notificationType = 3;
        this.selectedUser.forEach(element => {
          sendvalueArray.push(element.email);
        });
        if (this.keysvalue.length != 0) {
          if (this.sendViaCheckTempleat == 1) {
            this.setTheuserInfo('email', this.selectedUser);
            // console.log(this.userInfoWithParams)
            let data = {
              sendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
              sendValue: sendvalueArray,
              messageTitle: '',
              messageBody: '',
              notificationType: notificationType,
              userInfoWithParams: this.userInfoWithParams,
              severity: 0,
              emailTemplateId: this.selectedTemplate.id,
              isHTML: true
            }
            this.sendnotification(data);
          } else {
            let data = {
              messageTitle: this.notification.messageTitle,
              messageBody: (this.notificationPageType !== 'email' && this.notificationPageType !== 'sms') ? this.notification.messageBody : $('.summernote').summernote('code'),
              notificationType: notificationType,
              sendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
              sendValue: sendvalueArray,
              severity: 0,
              isHTML: true
            }
            this.sendnotification(data);
          }

        } else {
          if (this.sendViaCheckTempleat == 1) {
            Object.assign(emailOption, { ['senderModule']: '', ['templateId']: this.selectedTemplate.id, ['params']: this.keysvalue, ['attachment']: [], ['emails']: [] })
            let data = {
              sendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
              sendValue: sendvalueArray,
              messageTitle: '',
              messageBody: '',
              notificationType: notificationType,
              severity: 0,
              emailOptions: emailOption,
              isHTML: true
            }
            this.sendnotification(data);
          } else {
            let data = {
              messageTitle: this.notification.messageTitle,
              messageBody: (this.notificationPageType !== 'email' && this.notificationPageType !== 'sms') ? this.notification.messageBody : $('.summernote').summernote('code'),
              notificationType: notificationType,
              sendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
              sendValue: sendvalueArray,
              severity: 0,
              isHTML: true
            }
            this.sendnotification(data);
          }
        }
      } else if (this.notificationPageType === 'sms') {
        notificationType = 4;
        this.selectedUser.forEach(element => {
          sendvalueArray.push(element.phoneNumber);
        });
        if (this.keysvalue.length != 0) {
          if (this.sendViaCheckTempleat == 1) {
            this.setTheuserInfo('phoneNumber', this.selectedUser);
            let data = {
              sendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
              sendValue: sendvalueArray,
              messageTitle: '',
              messageBody: '',
              notificationType: notificationType,
              userInfoWithParams: this.userInfoWithParams,
              severity: 0,
              emailTemplateId: this.selectedTemplate.id,
              isHTML: true
            }
            this.sendnotification(data);

          } else {

            let data = {
              messageTitle: this.notification.messageTitle,
              messageBody: (this.notificationPageType !== 'email' && this.notificationPageType !== 'sms') ? this.notification.messageBody : $('.summernote').summernote('code'),
              notificationType: notificationType,
              sendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
              sendValue: sendvalueArray,
              severity: 0,
              isHTML: true
            }
            this.sendnotification(data);
          }
        }
        else {
          if (this.sendViaCheckTempleat == 1) {
            Object.assign(emailOption, { ['senderModule']: '', ['templateId']: this.selectedTemplate.id, ['params']: this.keysvalue, ['attachment']: [], ['emails']: [] })
            let data = {
              sendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
              sendValue: sendvalueArray,
              messageTitle: '',
              messageBody: '',
              notificationType: notificationType,
              severity: 0,
              emailOptions: emailOption,
              isHTML: true
            }
            this.sendnotification(data);

          } else {
            let data = {
              messageTitle: this.notification.messageTitle,
              messageBody: (this.notificationPageType !== 'email' && this.notificationPageType !== 'sms') ? this.notification.messageBody : $('.summernote').summernote('code'),
              notificationType: notificationType,
              sendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
              sendValue: sendvalueArray,
              severity: 0,
              isHTML: true
            }
            this.sendnotification(data);
          }

        }

      } else if (this.notificationPageType === 'notification') {
        notificationType = 1;
        if (this.sendViaCheck == 1) {
          this.selectedUser.forEach(element => {
            sendvalueArray.push(element.phoneNumber);
          });
          // sendvalueArray.push(this.notification.phone);
        }
        else if (this.sendViaCheck == 2) {
          this.selectedUser.forEach(element => {
            sendvalueArray.push(element.email);
          });
          // sendvalueArray.push(this.notification.email);
        }
        else if (this.sendViaCheck == 3) {
          this.selectedUser.forEach(element => {
            sendvalueArray.push(element.userName);
          });
        }else if (this.sendViaCheck == 0) {
          sendvalueArray = [];
             }

        let data = {
          MessageTitle: this.notification.messageTitle,
          MessageBody: (this.notificationPageType !== 'email' && this.notificationPageType !== 'sms') ? this.notification.messageBody : $('.summernote').summernote('code'),
          PushNotificationOptions: {
             Topics: (!!this.selectedTopic) ? this.selectedTopic : 0,
            DesitinationType: 2

            // (this.notificationPageType === 'notification') ? this.selectedPlatform.id : 2
          },
          NotificationType: notificationType,
          SendVia: (this.sendViaCheck) ? this.sendViaCheck : 0,
          SendValue: sendvalueArray
    
        }
        this.sendnotification(data);
      }
    } else {
      this.openNotifyError("Select Usrs OR Topic To Send " + this.notificationPageType);
      this.userRequired = true;
    }

  }
  // # to select the vlaues form the hover part  
  bindSelection() {
    this.context.message = window.getSelection().toString();
    if (this.context.message != null && this.context.message != "") {
      let whiteSpaceValue = this.context.message;
      this.keysvalue.push({ key: whiteSpaceValue.replace(/\s/g, ''), value: null });
      this.isOpen = true;
    }
  }


  // # to remove all the keys form the keyvalues  when the template change ;
  changeTheTemplate() {
    this.keysvalue = [];
  }

  // # to remove a key form the keyvalues that got selected 
  removeKey(index: any) {
    this.keysvalue.splice(index, 1);
  }


  // # sending the user for the tempelet editor after confirm  .
  // # check fomr the confrimation in the html 
  editTempleat() {
    this.router.navigate(["/email-template/edit/" + this.selectedTemplate.id]);
  }


  // # save the selected key and the index for that key form the array 
  selectedKey(item: any, key: any) {
    this.curuntKey = {
      itemData: item,
      index: key

    }
  }
  // # Set a value for the selected  key and  save it in the keys array as object of  key and value   
  setKeyValue(indexFortheKeysValue: any) {
    this.keysvalue[indexFortheKeysValue] = { key: this.curuntKey.itemData.key, value: this.keysConfiguration[this.selectedKeyValue] };
    this.selectedKeyValue = null;
    this.selectedKey(null, null)
  }



  setTheuserInfo(type: any, users: any) {
    type ObjectKey = keyof typeof users;
    let userPrams = [];
    for (let i = 0; i < this.selectedUser.length; i++) {
      const user = this.selectedUser[i];
      // # this one for add the key and the value 
      for (let J = 0; J < this.keysvalue.length; J++) {
        // # assign the selected vaule form the configration  
        let selectedValue = this.keysvalue[J].value
        userPrams[J] = { param: this.keysvalue[J].key, value: this.selectedUser[i][selectedValue] }
      }
      // # here we assign the the prams to the user eamil  to be a object  
      // # it will look like  ( { user@gmail.com : ["param" : "${{param_name}}" , "value": "param_value"] })
      Object.assign(this.userInfoWithParams, { [this.selectedUser[i][type as ObjectKey]]: userPrams })
    }

  }





// Function to select all users
selectAll() {
  this.selectedUser = [...this.usersList];
}

// Function to deselect all users
deselectAll() {
  this.selectedUser = [];
}

// Function to handle individual item selection
onItemSelect(event: Event, item: any) {
  const isChecked = (event.target as HTMLInputElement).checked;
  if (isChecked) {
    this.selectedUser.push(item);
  } else {
    this.selectedUser = this.selectedUser.filter(user => user !== item);
  }
}

// Function to check if all users are selected
isAllSelected(): boolean {
  return this.selectedUser.length === this.usersList.length;
}


  sendnotification(data: any) {
    this.httpClient.post(`/Notification/send`, data).subscribe((res: any) => {
      // this.groupLst = res;
      this.router.navigateByUrl('/notifications');
      this.snotifyService.success("", "Notification send successfully", {
        timeOut: 2000,
        progressBar: true,
        tapToDismiss: true,
      });
    }, (err) => {
      this.openNotifyError(err ? err.message : "Something went wrong");
      // this.router.navigateByUrl('/notifications');

    });
  }



  openNotifyError(message: string) {
    this.snotifyService.error(message, "", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }




}
